module.exports = __webpack_public_path__ + "static/media/Receivable.c7cc475d.svg";